/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Entity } from './entity';

export class TableEntity extends Entity {
  public base;
  constructor(base: any) {
    super();
    this.base = base;
    for (const attr in base) {
      this[attr] = base[attr];
    }
  }
  override convert(item): Entity {
    return new TableEntity(item);
  }

  getApi(): string {
    return '';
  }

  getId(): string {
    return this.base.id;
  }

  getLabel(): string {
    return this.base.label;
  }

  serialize() {
    const obj: any = {};
    for (const prop in this) {
      if (prop !== 'base' && !(this[prop] instanceof Function)) {
        obj[prop] = this[prop];
      }
    }
    return obj;
  }
}
